import React from 'react';
import PropTypes from 'prop-types';

import classes from './SchneiderTopBar.css';
import toolbarLogo from '../../../assets/images/se-logo-white.svg';
import canadaLogo from '../../../assets/images/canada.svg';
import usaLogo from '../../../assets/images/usa.svg';
import HambergerBtn from '../HambergerBtn/HambergerBtn';

const schneiderTopBar = props => {
  const { country, sideMenuTriggered, sideMenuHandler } = props;
  return (
    <header className={classes.SchneiderTopBar}>
      <img src={toolbarLogo} alt="Schneider Logo" />
      {country === 'Canada' ? (
        <img src={canadaLogo} alt="canada-logo" />
      ) : (
        <img src={usaLogo} alt="usa-logo" />
      )}
      <HambergerBtn
        sideMenuTriggered={sideMenuTriggered}
        sideMenuHandler={sideMenuHandler}
      />
    </header>
  );
};

schneiderTopBar.propTypes = {
  country: PropTypes.string.isRequired,
  sideMenuTriggered: PropTypes.bool,
  sideMenuHandler: PropTypes.func
};

export default schneiderTopBar;
